import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=1251d096&scoped=true"
import script from "./FilterCategory.vue?vue&type=script&lang=ts"
export * from "./FilterCategory.vue?vue&type=script&lang=ts"
import style0 from "./FilterCategory.vue?vue&type=style&index=0&id=1251d096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251d096",
  null
  
)

export default component.exports